export enum NoteTypeEnum {
  ValidValueName  = 'enumNoteType',
  Patient         = '00000019-1000-0000-0000-000000000001',
  Case            = '00000019-1000-0000-0000-000000000002',
  Private         = '00000019-1000-0000-0000-000000000003',
  Administartive  = '00000019-1000-0000-0000-000000000004',
  Hidden          = '00000019-1000-0000-0000-000000000005',
  Alert           = '00000019-1000-0000-0000-000000000006'
}
